'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceConfigurationPropType = _propTypes2.default.shape({
  serviceUrl: _propTypes2.default.string
});

exports.default = serviceConfigurationPropType;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PropTypes/serviceConfigurationPropType.js
// module id = 41
// module chunks = 11